// Webpack Imports
import * as bootstrap from 'bootstrap';
import Cookies from 'js-cookie';
import slick from 'slick-carousel';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();
$.fn.visible = function(partial) {
	var $t            = $(this),
	    $w            = $(window),
	    viewTop       = $w.scrollTop(),
	    viewBottom    = viewTop + $w.height(),
	    _top          = $t.offset().top,
	    _bottom       = _top + $t.height(),
	    compareTop    = partial === true ? _bottom : _top,
	    compareBottom = partial === true ? _top : _bottom;
      
	return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
};
$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();
      
	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();
      
	return elementBottom > viewportTop && elementTop < viewportBottom;
};
      
function parallaxEffect(target, data_smooth) {
	var element = $(target);

	element.each(function (i, el) {
		
		var move = $(el);
		$(window).scroll(function (event) {
		var top =  move.offset().top - $(this).scrollTop();
			
		if (move.visible(true)) {

			move.addClass("moving-target").css({
			"transform": "translateY(" + top / data_smooth + "px)",
			"-webkit-transform": "translateY(" + top / data_smooth + "px)",
			"-moz-transform": "translateY(" + top / data_smooth + "px)"
			});

		} else {
			move.removeClass("moving-target");
		}

		});
	});
}

function scrollAnimaitons(target, data_smooth, transitionTime, animationType, delay, rotate) {
	var element = $(target);

	if (transitionTime == 'undefined') {
		transitionTime = 0;
	}
	if (animationType == 'undefined') {
		animationType = 'ease';
	}

	element.each(function (i, el) {

		//General Styles
		$(el).css({
			"transition": "all "+ transitionTime + "s " + animationType,
			"-webkit-transition": "all "+ transitionTime + "s " + animationType,
			"-moz-transition": "all "+ transitionTime + "s " + animationType,
			"transition-delay": delay + "s",
			"-webkit-transition-delay": delay + "s",
			"-moz-transition-delay": delay + "s"
		})
		var move = $(el);
		var lastScrollTop = 0;
		$(window).scroll(function (event) {
			var st = $(this).scrollTop();
			if (!rotate) {
				var top =  move.offset().top - $(this).scrollTop();
			
				if (move.visible(true)) {

					move.addClass("moving-target").css({
						"transform": "translateY(" + top / data_smooth + "px)",
						"-webkit-transform": "translateY(" + top / data_smooth + "px)",
						"-moz-transform": "translateY(" + top / data_smooth + "px)"
					});

				} else {
					move.removeClass("moving-target");
				}
			} else {
				if (move.visible(true)) {

					move.addClass("moving-target");
					if (st > lastScrollTop){
						move.css({
							"transform": "rotate(" +  (data_smooth++)/3 + "deg)",
							"-webkit-transform": "rotate(" + (data_smooth++)/3 + "deg)",
							"-moz-transform": "rotate(" + (data_smooth++)/3 + "deg)"
						});
					} else {
						move.css({
							"transform": "rotate(" + (data_smooth--)/3 + "deg)",
							"-webkit-transform": "rotate(" + (data_smooth--)/3 + "deg)",
							"-moz-transform": "rotate(" + (data_smooth--)/3 + "deg)"
						});
					}
					lastScrollTop = st;


				} else {
					move.removeClass("moving-target");
				}
			}
		

		});
	});
}
function wordsTyping(words, id, colors, console) {
  if (colors === undefined) colors = ['#fff'];
  var visible = true;
  var con = document.getElementById(console);
  var letterCount = 1;
  var x = 1;
  var waiting = false;
  var target = document.getElementById(id)
  target.setAttribute('style', 'color:' + colors[0])
  window.setInterval(function() {

    if (letterCount === 0 && waiting === false) {
      waiting = true;
      target.innerHTML = words[0].substring(0, letterCount)
      window.setTimeout(function() {
        var usedColor = colors.shift();
        colors.push(usedColor);
        var usedWord = words.shift();
        words.push(usedWord);
        x = 1;
        target.setAttribute('style', 'color:' + colors[0])
        letterCount += x;
        waiting = false;
      }, 1000)
    } else if (letterCount === words[0].length + 1 && waiting === false) {
      waiting = true;
      window.setTimeout(function() {
        x = -1;
        letterCount += x;
        waiting = false;
      }, 2000)
    } else if (waiting === false) {
      target.innerHTML = words[0].substring(0, letterCount)
      letterCount += x;
    }
  }, 60)
  window.setInterval(function() {
    if (visible === true) {
      con.className = 'console-underscore hidden'
      visible = false;

    } else {
      con.className = 'console-underscore'

      visible = true;
    }
  }, 400)
}

//Numbers Counter  
function animateValue(obj, end, duration, step) {
	$(window).on('resize scroll', function() {
		if ($(obj).isInViewport()) {
			if (window.matchMedia("(max-width: 767px)").matches) {
				$(obj).text(end);
			} else {
				$(obj).addClass('run');
				if ($(obj).hasClass('run')) {
					anime({
						targets: obj,
						textContent: end,
						round: step,
						easing: 'easeInOutQuad',
						duration: duration
					});
				}
			}
			
		} else {
		    // do something else
		}
	      });  
}

//inits
if ($('.nubmer').length) {
	animateValue('#replatforming', '450', 2000, 1);
	animateValue('#entities', '7000000', 2000, 1);
	animateValue('#projects-f', '1', 2000, 1);
}


// scrollAnimaitons(target, data_smooth, transitionTime, animationType, delay, rotate)
scrollAnimaitons($('.dec-element'), 10);
scrollAnimaitons($('.picture-parallax'), 13);
scrollAnimaitons($('.online-store .picture-parallax'), 8);

scrollAnimaitons($('.inq-now .svg-wrapper svg'), 1, 0.1, 'ease', 0, true );

// function([string1, string2],target id,[color1,color2], console)   
 if ($('.console-container').length) {
wordsTyping(
	[
		'Magento',
	 	'Wix',
		'Shopify',
		'WooCommerce',
		'Squarespace',
		'PrestaShop',
		'OpenCart',
		'CS-Cart',
		'Bigcommerce',
		'ShopWare',
		'Volusion',
		'osCommerce',
		'Ecwid',
	],
	'textFrom',
	 [
		 '#4262ff'
	],
	'consoleFrom'
);
setTimeout(function(){
	wordsTyping(
		[
			'WooCommerce',
			'Wix',
			'Magento',
			'Shopify',
			'CS-Cart',
			'Bigcommerce',
			'PrestaShop',
			'Squarespace',
			'ShopWare',
			'Ecwid',
			'OpenCart',
			'osCommerce',
			'Volusion',
		],
		'textTo',
			[
				'#F9DB51'
		],
		'consoleTo'
		);
},1000)
	
wordsTyping(
	[
		'Automated Service',
		'Yourself',
		'Freelancer',
		'Migration Module',

	],
		'notA',
		 [
			'#191733'
		],
		'consoleNotA'
);
}

$( document ).ready(function() {

	var timeline = anime.timeline({ autoplay: true, loop: true, direction: 'alternate' });

	timeline.add({
		targets: "#fire",
		points: [
			{
				value: '56.3000148 271 89.2820175 271 106.891286 346.276219 91.5278339 319.605829 83.3008398 337.130149 74.5941178 289.924234 72.6336525 346.276219 60.3194776 312.384351 43.6528046 337.130149',
				duration: 200,
      				easing: 'linear'
			},

		]
	})

	$(document).on('submit','form.contact-mail',function(){
		if ($('#input-email').val() !== '' || $('#input-email').val() !== 'undefined' ) {
			Cookies.set('user_mail', $('#input-email').val(), { expires: 3 });
		}

	});
	if ($('.wpcf7-form').length){
		$('input[type="email"]').val(Cookies.get('user_mail'))
	}
	$('.review-row.slider').slick({
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		centerMode: true,
		centerPadding: '20px',
		adaptiveHeight: true
	});

});